module.exports = __webpack_public_path__ + "img/bar-chart-steps.f80d04e2.svg";